<div fxLayout="column" fxLayoutAlign="center top">
  <app-spinner *ngIf="!projectIsLoaded"></app-spinner>
  <app-editor (update)="updateProject($event)"
              [content]="project.concept"
              fxFlex="100"></app-editor>
</div>
